import { InjectionToken } from '@angular/core';
import { NgxScrollPositionRestorationConfig } from './ngx-scroll-position-restoration-config';

export const NGX_SCROLL_POSITION_RESTORATION_CONFIG_INJECTION_TOKEN = new InjectionToken<NgxScrollPositionRestorationConfig>('ngx_scroll_position_restoration_config_injection_token');
